import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Typography, Button } from '@material-tailwind/react';

const ErrorX = ({ title, message, onRetry }) => {
    return (
        <div className="p-4 md:p-6">
            {title}
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <Typography variant="small" className="text-red-700 flex items-center">
                    <AlertCircle className="h-4 w-4 mr-2" />
                    {message}
                </Typography>
                <Button onClick={onRetry} color="red" variant="text" className="mt-2 flex items-center gap-2">
                    <RefreshCw className="h-4 w-4" />
                    Retry
                </Button>
            </div>
        </div>
    );
};

export default ErrorX;
